<template>
    <div class="error-module">
        <div class="error-module__wrapper">
            <img :src="image" :alt="title" />
            <h3>{{ title }}</h3>
            <p>{{ subtitle }}</p>
            <ButtonComponent label="Go back" @click="onGoBack()" />
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

export default {
    name: "ErrorModule",
    setup() {
        const route = useRouter();
        const { currentRoute } = route;

        const title = ref("");
        const subtitle = ref("");
        const image = ref("");

        onMounted(() => {
            switch (currentRoute.value.params.code) {
            case "404":
                title.value = "Page Not Found";
                subtitle.value =
                        "This page may be broken or the page may have been removed or renamed.";
                image.value = "/img/error/404.svg";
                break;
            case "500":
                title.value = "Internal Server Error";
                subtitle.value =
                        "We’re experiencing an internal server problem. Please try again later.";
                image.value = "/img/error/500.svg";
                break;
            }
        });

        const onGoBack = () => {
            window.location.href = "/report/dashboard";
        };

        return {
            title,
            subtitle,
            image,
            onGoBack
        };
    },
};
</script>

<style lang="scss">
.error-module {
    @apply flex justify-center items-center min-h-screen;
    &__wrapper {
        @apply text-center p-4;
        img {
            @apply mb-10 w-3/4 sm:w-full mx-auto;
        }
        h3 {
            @apply sm:text-3xl text-2xl text-gray-800 mb-2;
        }
        p {
            @apply leading-5 sm:text-sm text-xs font-normal text-gray-500 mb-6;
        }
    }
}
</style>